<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <form-errors></form-errors>
  <div>
    <label>Name</label>
    <input formControlName="name" checkTouch [focus]="true" placeholder="Enter swimlane name">
    <help-block [control]="form.get('name')" [messages]="messages"></help-block>
  </div>
</form>
